const e=e=>1e3*e,o=e=>e/1e3;export{o as millisecondsToSeconds,e as secondsToMilliseconds};
